import { render, staticRenderFns } from "./CreateBlocked.vue?vue&type=template&id=b8b94592"
import script from "./CreateBlocked.vue?vue&type=script&lang=js"
export * from "./CreateBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports